import { OrderItem as OrderItemType } from "@/lib/types/orderItem";

export const getProductType = (
  item: OrderItemType | string | undefined
): string => {
  const comparitor = typeof item == "string" ? item : item?.mainTaxonSlug;

  if (!comparitor) return "";

  switch (true) {
    case comparitor.includes("cigar") ||
      comparitor.includes("category_cigar"):
      return "cigars";
    case comparitor.includes("beer") ||
      comparitor.includes("category_beer"):
      return "beer";
    case comparitor.includes("food") ||
      comparitor.includes("category_food"):
      return "foods";
    case comparitor.includes("spirit") ||
      comparitor.includes("category_spirit"):
      return "spirits";
    case comparitor.includes("gifts") ||
      comparitor.includes("category_gifts"):
      return "gifts";
    case comparitor.includes("wine") ||
      comparitor.includes("category_wine"):
      return "wine";
    default:
      return "";
  }
};
